<template>
  <div class="login">
    <!-- <div class="logo">
      <img src="" alt="">
    </div> -->
    <div class="title">
      {{ loginConfig.title }}
      <!-- Hi，欢迎来到“多测合一” <br />
      网上办事大厅 -->
    </div>
    <div class="login-box">
      <van-tabs v-model="active" color="#1989fa" class="tabs">
        <!-- <van-tab title="账号登录" name="账号登录"></van-tab>
        <van-tab title="手机号登录" name="手机号登录"></van-tab> -->
        <van-tab :title="tab" :name="tab" v-for="(tab,t) in loginConfig.loginWay" :key="t"></van-tab>
        <div class="login-form" v-if="active=='账号登录'">
          <van-field
            class="login-field"
            v-model="accuntParams.loginName"
            label="帐号"
            placeholder="请输入您的用户名/统一社会信用代码"
          />
          <van-field
            class="login-field"
            v-model="accuntParams.password"
            :type="passwordType"
            label="密码"
            placeholder="请输入登录密码"
          >
            <template #button>
              <van-image
                @click="switchType"
                width="18"
                height="12"
                :src="require(`@/assets/img/common/icon-eyes${passwordType=='password' ? '-o' : ''}.png`)"
              ></van-image>
            </template>
          </van-field>
          <van-field disabled></van-field>
        </div>
        <div class="login-form" v-if="active=='手机号登录'">
          <van-field
            v-model="phoneParams.mobilePhone"
            label="手机号"
            placeholder="请输入手机号"
          />
          <van-field
            v-model="phoneParams.validate"
            center
            clearable
            label="短信验证码"
            placeholder="请输入短信验证码"
          >
            <template #button>
              <van-button plain type="info" size="small" class="code-btn" @click="sendCode">
                {{ num==60 ? '发送验证码' : `${num}s` }}
              </van-button>
            </template>
          </van-field>
          <van-field disabled></van-field>
        </div>
      </van-tabs>
      
      <div class="btn-group">
        <van-button block class="login-btn" @click.stop="login">
          {{ normalText }}
        </van-button>
        <div class="text-btn">
          <div class="btn" @click="jumpPath('Register')">立即注册</div>
          <div class="line" v-if="loginConfig.isHaveForgetPwd==1"></div>
          <div class="btn" v-if="loginConfig.isHaveForgetPwd==1" @click.stop="jumpPath('ForgetPassword')">忘记密码</div>
        </div>
      </div>
    </div>
    <ThirdParty v-if="loginConfig.isHaveThirdLogin=='1'" />
  </div>
</template>

<script>
import api from '@/utils/api/personCenter'
import MD5 from 'md5.js'
import ThirdParty from './components/third-party'
import moduleMixins from '@/mixins/moduleMixins'
export default {
  name: 'login',
  components: { ThirdParty },
  mixins: [moduleMixins],
  props: {},
  data() {
    return {
      loginConfig: {
        loginWay: []
      },
      active: null,
      accuntParams: {
        loginName: '',
        password: '',
      },
      num: 60,
      phoneParams: {
        mobilePhone: '',
        validate: '',
      },
      passwordType: 'password',
      thirdType: 0,
      normalText: '登录'
    }
  },
  watch: {},
  computed: {
    navTitle() {
      return '登录'
    }
  },
  methods: {
    jumpPath(name) {
      this.$router.push({ name })
    },
    switchType() {
      if (this.passwordType == 'password') {
        this.passwordType = 'text'
      } else {
        this.passwordType = 'password'
      }
    },
    sendCode() {
      if(this.num!=60) return
      if(!this.phoneParams.mobilePhone) {
        this.$toast('请输入手机号')
        return
      }
      api.sendVerification({
        mobileNo: this.phoneParams.mobilePhone
      }).then(() => {
        this.$toast('发送成功')
        let timer = setInterval(()=> {
          this.num--
          if(this.num <= 0) {
            clearInterval(timer)
            this.num = 60
          }
        }, 1000)
      })
      
    },
    login() {
      let apiLoginIn = {}
      if(this.active=='账号登录') {
        const md5Password = new MD5().update(this.accuntParams.password).digest('hex')
        apiLoginIn = api.loginIn({
          loginName: this.accuntParams.loginName,
          password: md5Password
        })
      } else {
        apiLoginIn = api.loginInByPhone(this.phoneParams)
      }
      console.log(this.active, this.active=='账号登录' )

      apiLoginIn.then(res => {
        this.$store.commit('setUserInfo', res.data)
        this.$store.state.token = res.data.token
        localStorage.setItem('Token', res.data.token)
        //登录成功，返回上一层，加刷新
        if (this.loginConfig.isHaveThirdLogin == 0) {
          this.$toast({
            type: 'success',
            message: '登录成功！',
            icon: 'passed',
            duration: 1500,
            onClose: () => {
              //普通登录
              // this.$bus.$emit('btnLogin')
              if (window.__wxjs_environment === 'miniprogram') {
                wx.miniProgram.postMessage({ data: res.data.token })
                // wx.miniProgram.navigateTo({
                //   url: '/pages/web/web?webUrl=home&token=' + res.data.token
                // })
                wx.miniProgram.navigateBack()
              } else {
                this.$router.go(-1)
                // this.$router.replace({ name: 'Home' })
              }
            }
          })
        } //else if (this.loginConfig.isHaveThirdLogin == 1) {
        //普通登录加人脸识别,判断是否在小程序
        //  this.$bus.$emit('btnLogin')
        //  this.$router.go(-1)
        // if (window.__wxjs_environment === 'miniprogram') {
        //   if (res.LXR == '' && res.ZJHM == '') {
        //     this.$toast('请完善信息')
        //   } else {
        //     wx.miniProgram.navigateTo({
        //       url: '/pages/face/face?name=' + res.LXR + '&ZJHM=' + res.ZJHM
        //     })
        //   }
        // } else {
        //   this.$toast('请使用小程序登录')
        // }
        //  }
      })
      .catch(err => {
        this.$toast(err.response.data.message)
      })
    },
    // 获取登录、注册页面配置
    getLoginCofig() {
      api.getLoginConfig().then(res => {
        console.log(res)
        this.loginConfig = res.data
        this.active = this.loginConfig.loginWay[0]
        this.$store.state.loginConfig = this.loginConfig
      })
    }
  },
  created() {},
  mounted() {
    this.getLoginCofig()
    //  console.log('login', this.$store.state.loginInfo)
  }
}
</script>
<style lang="scss" scoped>
.login {
  background-color: #fff;
  height: 100vh;
  .logo {
    padding: 20px;
    background-color: #f0f5fe;
  }
  .title {
    background-color: #f0f5fe;
    padding: 30px 50px;
    font-size: 24px;
    line-height: 1.5;
  }
  .login-box {
    .login-form {
      padding: 15px 20px;
      .code-btn {
        border: 0;
      }
    }
    ::v-deep .tabs {
      height: 220px;
      .van-tabs__wrap {
        // width: 80%;
        margin: 0 auto;
      }
      .van-tab--active {
        color: #1d84ff;
      }
      .van-tabs__line {
        width: 40%;
      }
      .van-cell {
        display: block;
        ::v-deep .van-field__label {
          width: 100%;
          padding-bottom: 5px;
        }
      }
    }
    
    .btn-group {
      padding: 0px 15px 50px;
      .login-btn {
        background: #1d84ff;
        box-shadow: 0px 2px 6px 0px rgba(29, 132, 255, 0.5);
        border-radius: 5px;
        text-align: center;
        font-size: 16px;
        font-weight: bold;
        color: #ffffff;
        height: 44px;
        border: 1px solid transparent;
        margin-top: 30px;
      }
      .text-btn {
        display: flex;
        justify-content: center;
        text-align: center;
        font-size: 15px;
        .btn {
          padding: 10px 15px;
          color: #1d84ff;
        }
        .line {
          height: 15px;
          width: 1px;
          background: #DDDDDD;
          transform: translateY(13px);
        }
      }
    }
  }
}
</style>
